export default "__VITE_ASSET__DCpP4TGs__"